import React, {useEffect} from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
// Form related
import { Field } from 'formik';
import {RadioGroup} from 'formik-material-ui';
import { DatePicker } from 'formik-material-ui-pickers';
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter";
import Table from "components/Table/Table.js";
import AddressInput from "components/AddressInput/AddressInput";
import fieldData from '../FormModel/fieldData.js';
import CustomImageInput from "../../../components/CustomImageInput/CustomImageInput";

import connectionFormStyle from "../../../assets/jss/material-dashboard-react/views/connectionFormStyle";
import {FormControlLabel, Radio} from "@material-ui/core";

const state = fieldData.state;
const useStyles = makeStyles(connectionFormStyle);

export default function CustomerDetails(props) {
    const {formField, setFieldValue, values} = props;
    const classes = useStyles();

    const customer_type_options = formField.customer_type.options.map((item) =>
        <FormControlLabel
            key={item.value}
            value={item.value}
            control={<Radio />}
            label={item.label}
        />
    );

    useEffect(() => {
        setFieldValue(formField.customer_contact_address.fields.street.name, values[formField.current_trading_address.fields.street.name]);
        setFieldValue(formField.customer_contact_address.fields.state.name, values[formField.current_trading_address.fields.state.name]);
        setFieldValue(formField.customer_contact_address.fields.postcode.name, values[formField.current_trading_address.fields.postcode.name]);
    }, []);


    return (
        <div>
            <GridContainer>
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary">
                            <h4 className={classes.cardTitleWhite}>2 | Customer Details</h4>
                        </CardHeader>
                        <CardBody>
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={6}>
                                    <FormControl component="fieldset" className={classes.formControl}>
                                        <Field component={RadioGroup} name={formField.customer_type.name} className={classes.formGroupHorizontal}>
                                            {customer_type_options}
                                        </Field>
                                    </FormControl>
                                    <Field
                                        component={CustomInput}
                                        labelText={formField.title.label}
                                        name={formField.title.name}
                                        id={formField.title.name}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                    <Field
                                        component={CustomInput}
                                        labelText={formField.given_name.label}
                                        name={formField.given_name.name}
                                        id={formField.given_name.name}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                    <Field
                                        component={CustomInput}
                                        labelText={formField.surname.label}
                                        name={formField.surname.name}
                                        id={formField.surname.name}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                    <Field
                                        component={CustomInput}
                                        labelText={formField.position_in_company.label}
                                        name={formField.position_in_company.name}
                                        id={formField.position_in_company.name}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                    <Field
                                        component={DatePicker}
                                        format="DD/MM/yyyy"
                                        name={formField.date_of_birth.name}
                                        id={formField.date_of_birth.name}
                                        label={formField.date_of_birth.label}
                                        disableFuture={true}
                                        className={classes.itemSpacer + " " + classes.underline}
                                    />
                                    <Field
                                        component={CustomInput}
                                        labelText={formField.email.label}
                                        name={formField.email.name}
                                        id={formField.email.name}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            type: "email"
                                        }}
                                    />
                                    <Field
                                        component={CustomInput}
                                        labelText={formField.primary_contact_no.label}
                                        name={formField.primary_contact_no.name}
                                        id={formField.primary_contact_no.name}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                    <AddressInput formField={formField.customer_contact_address} classes={classes} states={state} />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6}>
                                    <Table
                                        size="small"
                                        style={{marginTop: "0px"}}
                                        tableHeaderColor="primary"
                                        tableHead={[formField.id1_type.label, formField.id1_ref_no.label, formField.id1_expiry_date.label]}
                                        tableData={[
                                            [
                                                <Field
                                                    component={CustomInput}
                                                    name={formField.id1_type.name}
                                                    formControlProps={{
                                                        fullWidth: true,
                                                        style: {margin: "0px"}
                                                    }}
                                                    inputProps={{
                                                        style:{margin: "0px"}
                                                    }}
                                                />,
                                                <Field
                                                    component={CustomInput}
                                                    name={formField.id1_ref_no.name}
                                                    formControlProps={{
                                                        fullWidth: true,
                                                        style: {margin: "0px"}
                                                    }}
                                                    inputProps={{
                                                        style:{margin: "0px"}
                                                    }}
                                                />,
                                                <Field
                                                    component={DatePicker}
                                                    format="DD/MM/yyyy"
                                                    name={formField.id1_expiry_date.name}
                                                    id={formField.id1_expiry_date.name}
                                                    disablePast={true}
                                                    className={classes.underline}
                                                    inputProps={{
                                                        style: {paddingTop: 0}
                                                    }}
                                                />
                                            ],
                                            [
                                                <Field
                                                    component={CustomInput}
                                                    name={formField.id2_type.name}
                                                    formControlProps={{
                                                        fullWidth: true,
                                                        style: {margin: "0px"}
                                                    }}
                                                    inputProps={{
                                                        style:{margin: "0px"}
                                                    }}
                                                />,
                                                <Field
                                                    component={CustomInput}
                                                    name={formField.id2_ref_no.name}
                                                    formControlProps={{
                                                        fullWidth: true,
                                                        style: {margin: "0px"}
                                                    }}
                                                    inputProps={{
                                                        style:{margin: "0px"}
                                                    }}
                                                />,
                                                <Field
                                                    component={DatePicker}
                                                    format="DD/MM/yyyy"
                                                    name={formField.id2_expiry_date.name}
                                                    id={formField.id2_expiry_date.name}
                                                    disablePast={true}
                                                    className={classes.underline}
                                                    inputProps={{
                                                        style: {paddingTop: 0}
                                                    }}
                                                />
                                            ]
                                        ]}
                                    />
                                    <GridContainer style={{paddingTop: "30px"}}>
                                        <GridItem xs={12} sm={6} md={12}>
                                            <Field
                                                name={formField.id1a_file.name}
                                                component={CustomImageInput}
                                                title={formField.id1a_file.label}
                                                setFieldValue={props.setFieldValue}
                                                style={{ display: "flex" }}
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={6} md={12} style={{marginTop: "15px"}}>
                                            <Field
                                                name={formField.id1b_file.name}
                                                component={CustomImageInput}
                                                title={formField.id1b_file.label}
                                                setFieldValue={props.setFieldValue}
                                                style={{ display: "flex" }}
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={6} md={12} style={{marginTop: "15px"}}>
                                            <Field
                                                name={formField.id2_file.name}
                                                component={CustomImageInput}
                                                title={formField.id2_file.label}
                                                setFieldValue={props.setFieldValue}
                                                style={{ display: "flex" }}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                </GridItem>
                            </GridContainer>
                        </CardBody>
                        <CardFooter>
                            &nbsp;
                        </CardFooter>
                    </Card>
                </GridItem>
            </GridContainer>
        </div>
    );
}
